import { Component, NgModule } from '@angular/core';
import { NavigationService } from './shared/services/navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { HttpClient } from '@angular/common/http';
import { NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TelegramService } from './telegram-services';

declare var gonative: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
 currentVersion = ''; 
 private lastSentUrl = '';

  constructor(
    private translate: TranslateService,
    public navigation: NavigationService,
    private storage: LocalStorageService,
    private http: HttpClient,
    private router: Router,
    private location : Location,
    private telegramService: TelegramService

  ) {

    this.navigation.startSaveHistory();
    this.telegramService.init();
    
  }
  initVersionCheck() {
    this.http.get<{ version: string }>('/assets/version.json', { headers: { 'Cache-Control': 'no-cache' } })
      .subscribe(res => {
        if (!this.currentVersion) {
          this.currentVersion = res.version;
          console.log('App version set:', this.currentVersion);
        } 
        else if (this.currentVersion !== res.version)
        {
        console.log(`New version detected (${res.version}), reloading...`);
         // window.location.href = window.location.href; // forces full reload
         //window.location.href = window.location.pathname + '?v=' + new Date().getTime();
         window.location.replace(location.origin + location.pathname + '?v=' + new Date().getTime());
         //ocation.replace(location.pathname + '?v=' + new Date().getTime());
        }
      });
  }
  async ngOnInit(): Promise<void> {
   //old facebook link => https://www.facebook.com/shwetigerapp
   //old viber link => viber://pa?chatURI=stiger
   //old telegram link => https://t.me/stiger004
   //old youtube link => https://www.youtube.com/channel/UCc8iXydNiJNUE9LOMlBxgcg?view_as=subscriber
   
   /***** If you want to clear all */
   //this.storage.clear();
   //localStorage.clear();
   //this.storage.clear('actionType');//Add This
   //this.storage.clear('actionType1');//Add This
   //this.storage.clear('localsmstype');
   //this.storage.clear('localtype');
   //localStorage.removeItem('time');
   //this.storage.clear('localPhoneNumber');
   //this.storage.clear('localOtpSms');

   //clear browser auto
  this.initVersionCheck();
  // check every 1 min
  setInterval(() => {
    this.initVersionCheck();
  }, 60000);

   this.setTranslate();
   
   if (navigator.userAgent.indexOf('gonative') > -1) {

        var items = [
          {
            label: "Facebook",
            url: "https://www.facebook.com/ShweTigerOfficial?mibextid=ZbWKwL"
          },
          {
            label: "YouTube",
            url: "https://youtube.com/@user-mi4kd2xn5v?si=MITqMThRUOppbQPN"
          },
          {
            label: "Viber",
            url: "https://invite.viber.com/?g2=AQANDKyCOpjJMFBEQsvskFwahAgFdnLevpWqhLnqu%2Bd5pLLdTJ1fcAHVG5j95Wk6",
          },
          {
            label: "Telegram",
            url: "https://t.me/shwetiger"
          }
        ];  
        gonative.sidebar.setItems({"items":items,"enabled":true, "persist":true});   

    }
    
    //For new app routes -- 20251214
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Convert router URL to absolute URL
        const normalizedUrl = this.normalizeUrl(event.urlAfterRedirects);

        // Skip duplicates
        if (this.lastSentUrl !== normalizedUrl) {
          this.lastSentUrl = normalizedUrl;
          // Send to React Native WebView if available
          if ((window as any).ReactNativeWebView) {
            (window as any).ReactNativeWebView.postMessage(
              JSON.stringify({ type: 'NAVIGATION', url: normalizedUrl })
            );
          }
          console.log('Pushed to history:', normalizedUrl);
        } else {
          console.log('Ignored duplicate URL:', normalizedUrl);
        }
      }
    });

    window.addEventListener('message', (event: MessageEvent) => {
      try {
        const data = JSON.parse(event.data);
        if (data.type === 'GO_BACK') {
          this.location.back();
        }
      } catch {}
    });
    
  }

  setTranslate() {
    this.translate.addLangs(["en", "my", "my_zawgyi", "th", "zh"]);
    this.translate.setDefaultLang("my");
    const currentLang = this.storage.retrieve("localLanguage");
    if(currentLang != null) 
    {
      this.storage.store("localLanguage", currentLang);
      this.translate.use(currentLang);
    }
    else
    {
      this.storage.store("localLanguage", "my");
      this.translate.use("my");
    }
  }

  onActivate() {
    window.scroll(0,0);
  }
 /**
   * Normalize URL to absolute format
   */
  private normalizeUrl(url: string): string {
    try {
      // Use current origin to convert relative -> absolute
      return new URL(url, window.location.origin).href;
    } catch (err) {
      // fallback if URL parsing fails
      console.warn('Failed to normalize URL:', url, err);
      return url;
    }
  }
}



